import { colors } from '@ui/colors'
import { StatusVariant } from '@ui/elements/Status/types'
import { UiVariant } from '@ui/theme/variants'
import { FrameStatus } from '@frame/StockUtils'
import { Platform } from 'react-native'
import { hex } from '@ui/utils/hex'

export type FrameVariant = Exclude<UiVariant, 'neutral' | 'warning'>

export const variantsMap: FrameVariant[] = [
  'disabled',
  'default',
  'active',
  'success',
  'danger',
  'attention',
]

export const colorActive: Record<FrameVariant, string> = {
  disabled: colors.neutral[300],
  default: colors.text,
  active: colors.blue[600],
  success: colors.green[700],
  danger: colors.red[700],
  attention: colors.orange[500],
}

export const colorInactive: Record<FrameVariant, string> = {
  disabled: colors.neutral[300],
  default: colors.text,
  active: colors.text,
  success: colorActive.success,
  danger: colorActive.danger,
  attention: colorActive.attention,
}

export const colorDetailText: Record<FrameVariant, string> = {
  disabled: colors.neutral[300],
  default: colors.text50,
  active: hex(colors.blue[600], 0.5),
  success: hex(colors.green[700], 0.5),
  danger: hex(colors.red[700], 0.5),
  attention: hex(colors.orange[500], 0.5),
}

export const colorDetailBorder: Record<FrameVariant, string> = {
  disabled: colors.black10,
  default: colors.text25,
  active: hex(colors.blue[600], 0.25),
  success: hex(colors.green[700], 0.25),
  danger: hex(colors.red[700], 0.25),
  attention: hex(colors.orange[500], 0.25),
}

export const statusToVariant: Record<FrameStatus, FrameVariant> = {
  selected: 'active',
  saved: 'success',
  available: 'default',
  limited: 'default',
  out: 'danger',
  minPrice: 'danger',
  maxPrice: 'danger',
  requirements: 'danger',
}

export const statusToBadge: Record<FrameStatus, StatusVariant | undefined> = {
  selected: undefined,
  saved: 'success',
  available: undefined,
  limited: 'neutral',
  out: 'danger',
  minPrice: 'danger',
  maxPrice: 'danger',
  requirements: 'danger',
}

export const getHeight = (isCheckable: boolean) => (isCheckable ? 192 : 160)

export const styleImage = {
  width: Platform.select({
    default: 192,
    web: 256,
  }),
  height: Platform.select({
    default: 64,
    web: 96,
  }),
}
